import { connect } from "react-redux";
import { DanhSachThanhLy } from "components/DanhSachThanhLy";
import { getListDanhSachThanhLy } from "actions/DanhSachThanhLy";

const mapStateToProps = (state) => ({
  danhsachthanhly: state.danhsachthanhly,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListDanhSachThanhLy: (dataSearch) =>
    dispatch(getListDanhSachThanhLy(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachThanhLy);
